import { summary } from './bootMetrics';

const SUMMARY_DELAY_MS = 3000;

/**
 * Schedule the boot metrics summary to fire after a delay.
 *
 * The delay gives dashboard hooks time to mount and run their
 * `bootMetrics.cacheCheck` calls before `summary()` aggregates and
 * emits the Sentry breadcrumb + `boot.prefetch.allHit` tag.
 *
 * @returns The timeout handle (so callers can clear it if needed).
 */
export function scheduleBootSummary(): ReturnType<typeof setTimeout> {
  return setTimeout(() => {
    summary();
  }, SUMMARY_DELAY_MS);
}
